import { Controller } from '@hotwired/stimulus';
import { MaskInput } from 'maska';

export default class extends Controller {
  connect() {
    this.maskedInput = new MaskInput(this.element);

    if (this.element.dataset.maskaErrorMessage) {
      this.element.addEventListener('input', () => {
        this.element.setCustomValidity('');
        if (!this.element.checkValidity()) {
          this.element.setCustomValidity(this.element.dataset.maskaErrorMessage);
        }
      });
    }
  }

  disconnect() {
    this.maskedInput.destroy();
  }
}
